import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiCallAdmin } from "./services/api-service.js";
import { Container, Row, Col, Toast } from "react-bootstrap";
import dock_logo from "./assets/svg/dock_logo.svg";
function PreLanding() {
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await apiCallAdmin("GET", "get_role_permission/9", null, {
        params: {},
      });

      if (response?.status === 200) {
        navigate("/dashboard/default");
        return;
      }

      if (response?.status === 401) {
        document.cookie =
          "mawalog=; redirectPath=" +
          encodeURIComponent(window.location.href) +
          "; path=/; domain=.mawalog.com";
        window.location.href = accountsUrl;
        return;
      }

      console.error("Request failed:", response);
    };

    fetchData();
  }, [navigate]);

  return (
    <Container
      fluid
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        paddingLeft: "0px",
        paddingRight: "0px",
      }}
    >
      <img src={dock_logo} alt="Dock Icon" width={"500px"} />
    </Container>
  );
}

export default PreLanding;
